import {Component, OnInit} from '@angular/core';
import {Order} from '../../../services/order';
import {TenFourOrderService} from '../../../services/themes/10-4/ten-four-order.service';
import {OrderTypesService} from '../../../services/order-types.service';
import {OrderType} from '../../../services/order-type';
import {ICard} from '../../../widgets/card-select/card-select.component';
import {faPeopleCarry, faRulerCombined} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-select-new-order-type',
    templateUrl: './select-new-order-type.component.html',
    styleUrls: ['./select-new-order-type.component.scss'],
    providers: [OrderTypesService]
})
export class SelectNewOrderTypeComponent implements OnInit {

    order: Order;
    orderTypes: OrderType[];

    dataForCards: ICard[] = [];

    constructor(private orderService: TenFourOrderService,
                private orderTypesService: OrderTypesService) {
    }

    ngOnInit(): void {
        /**
         * Order
         */
        this.orderService.currentOrder.subscribe((response) => {
            this.order = response;
        });

        /**
         * Order types, mapping to card data
         */
        this.orderTypesService.getOrderTypes().subscribe((response) => {
            this.orderTypes = response.data;

            this.dataForCards = this.orderTypes.map((orderType) => {
                return {
                    name: orderType.name,
                    icon: faPeopleCarry,
                    emitValue: orderType.id,
                };
            });
        });
    }

    setNewOrderType(orderTypeId: string): void {
        this.order.order_type = this.orderTypes.find((orderType) => orderType.id === orderTypeId);
        this.orderService.setOrder(this.order);
    }
}
